import { pubsub } from '@services';

class StickyProductForm extends HTMLElement {
  submitButton = this.querySelector('button[type="submit"]');
  submitButtonText = this.submitButton?.querySelector('span');
  wishlistButton = this.querySelector('.button--wishlist');

  connectedCallback() {
    this.observeFooter();
    const { productId } = this.dataset;

    this.unsubscribeVariantChanged = pubsub.subscribe(`variant:changed:${productId}`, (html) =>
      this.handleVariantChange(html)
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChanged();
  }

  /**
   * Handle variant change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handleVariantChange({ html }) {
    if (!html) return;

    this.observeFooter();

    const { productForm, formButton, wishlistBtn } = this.selectElements(html);
    if (!productForm) return;

    this.syncSubmitButton(formButton);
    this.syncWishlist(wishlistBtn);
  }

  /**
   * Select the elements.
   * @param {HTMLElement} html - The HTML to render.
   * @returns {Object} - The selected elements.
   */
  selectElements(html) {
    const productForm = html.querySelector('product-form');
    const formButton = productForm?.querySelector('button[type="submit"]') ?? null;
    const wishlistBtn = html.querySelector('.button--wishlist') ?? null;

    return { productForm, formButton, wishlistBtn };
  }

  /**
   * Sync the submit button.
   * @param {HTMLElement} formButton - The form button.
   */
  syncSubmitButton(formButton) {
    if (!this.submitButton || !formButton) return;
    this.updateSubmitButtonText(formButton.textContent);
    this.updateOutOfStock(formButton.hasAttribute('data-out-of-stock'));
    this.updateDisabled(formButton.disabled);
  }

  /**
   * Update the submit button text.
   * @param {String} text - The text to update.
   */
  updateSubmitButtonText(text) {
    const clean = text?.trim();
    if (this.submitButtonText && clean) {
      this.submitButtonText.textContent = clean;
    }
  }

  /**
   * Update the out of stock attribute.
   * @param {Boolean} isOut - The out of stock attribute.
   */
  updateOutOfStock(isOut) {
    this.submitButton.toggleAttribute('data-out-of-stock', Boolean(isOut));
  }

  /**
   * Update the disabled state.
   * @param {Boolean} isDisabled - The disabled state.
   */
  updateDisabled(isDisabled) {
    this.submitButton.disabled = Boolean(isDisabled);
  }

  /**
   * Sync the wishlist button.
   * @param {HTMLElement} wishlistBtn - The wishlist button.
   */
  syncWishlist(wishlistBtn) {
    const variantId = wishlistBtn?.dataset?.variantId;
    if (this.wishlistButton && variantId) {
      this.wishlistButton.dataset.variantId = variantId;
    }
  }

  /**
   * Observe the footer.
   */
  observeFooter() {
    const footer = document.querySelector('footer');

    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      this.classList.toggle('translate-y-full', isIntersecting);
      this.classList.toggle('opacity-0', isIntersecting);
    });

    observer.observe(footer);
  }
}

customElements.define('sticky-add-to-cart', StickyProductForm);
